<template>
  <ViewCustomData entityName="property_data" entitySpec="data" serviceName="BaseService"
    :columns="PROPERTY_DATA_COLUMNS" :dictionary="PROPERTY_DATA_DICTIONARY" @selectedRow="onSelectedRow"
    :masterDetail="{ property_id: propertyId }" ref="viewProperty" scrollHeight="250px" :paginator="false" mode="edit"
    :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert" :prepareData="prepareData" :requiredFieldsTable="{
      property_attribute_id: true,
    }" />
</template>

<script setup>
import { PROPERTY_DATA_DICTIONARY, PROPERTY_DATA_COLUMNS } from './facilityConstants';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  propertyId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['loadData', 'selected']);

const toNull = (value) => {
  if (value === '') return null;
  return value;
};

const onSelectedRow = (value) => {
  if (value.property_attribute_id) {
    emit('selected', { property_attribute_id: value.property_attribute_id });
  }
};

const prepareUpdate = (rowData) => {
  return {
    property_data_id: rowData.property_data_id,
    property_id: props.propertyId,
    property_attribute_id: rowData.property_attribute_id,
    property_data_value: toNull(Number(rowData.property_data_value)),
    property_real_value: toNull(Number(rowData.property_real_value)),
    property_text_desc: toNull(rowData.property_text_desc),
  };
};

const prepareInsert = (rowData) => {
  rowData.property_id = props.propertyId;
  return rowData;
};

const prepareData = (data) => {
  emit('loadData', data, 'Property');
  return data;
};
</script>